"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const links = [
  ["/", "首页"], ["/story", "品牌故事"], ["/tea", "古树茶"],
  ["/hirudin", "水蛭素"], ["/jiuyuejie", "汣悦解"], ["/member", "会员中心"],
] as const;

export function DesktopNav() {
  const pathname = usePathname();
  if (pathname.startsWith("/admin")) return null;
  return (
    <nav aria-label="电脑端主要导航" className="desktop-nav">
      <Link href="/" className="desktop-nav-home">老挝·源头精选</Link>
      <div className="flex items-center gap-2">
        {links.map(([href, label]) => (
          <Link key={href} href={href} aria-current={(href === "/" ? pathname === href : pathname.startsWith(href)) ? "page" : undefined}>
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
